import Founder from "../../Assets/Images/founder.png";

const LegacyContent = () => {
  return (
    <section className="Legacy-content px-lg-5">
      <div className="container-fluid">
        <div className="row align-items-center  justify-content-between mb-lg-5 ">
          <div className="col-12  col-lg-6 col-xl-4  my-4 mb-lg-0 order-2 order-lg-2">
            <img
              src={Founder}
              alt="Shivanand & Sheetal Bagwe"
              className="img-fluid"
            />
          </div>

          <div className="col-12  col-lg-6 col-xl-6 order-1 order-lg-2 text-center">
            <h1 className="text-white pb-5 fw-normal">
              Our Journey into Event Management – A Legacy of Excellence and
              Innovation
            </h1>
            <p className="text-white">
              Our story began in 1993, when Ashok Bagwe’s forefathers
              established a printing business in Karachi. After the 1947
              partition, the family relocated to Mumbai and continued their
              printing legacy. Over the decades, this expertise in printing and
              content creation evolved, leading to the establishment of Sundaram
              Art Printing Press in 1998 by Ashok Bagwe.
            </p>
          </div>
        </div>

        <div className="mx-auto">
          <p className="text-white m-0">
            With a strong foundation in printing, the business flourished,
            expanding into multilingual book exports and setting new industry
            benchmarks. A new chapter began when Shivanand Bagwe, a graduate of
            JJ School of Art, joined the business, introducing fresh
            perspectives and modern design innovations. His wife, Sheetal Bagwe,
            an engineering graduate with a decade of IT experience, further
            contributed by focusing on expanding multilingual book exports and
            integrating digital solutions into the business. Together, their
            expertise propelled the company’s growth, adapting to evolving
            industry demands.
          </p>
          <p className="text-white m-0">
            Recognizing the shift toward digitalization, we embraced
            technology-driven innovations and established SAMS DIGITAL under the
            leadership of Sheetal Bagwe. This expansion allowed us to offer
            secure digital publications, website and app development, and
            digital marketing solutions. Through Sundaram Digital Publication
            House, we naturally ventured into book launch events and literary
            gatherings, providing a platform for authors, publishers, and
            industry leaders to showcase their work.
          </p>
          <p className="text-white">
            With each successful event, our capabilities in coordinating
            large-scale conferences, corporate events, and brand launches grew.
            Decades of expertise in design, branding, logistics, and audience
            engagement seamlessly translated into curating exceptional event
            experiences. Our ability to integrate traditional expertise with
            modern event solutions positioned us as a trusted name in the
            industry.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LegacyContent;
